import router from '../router'

export default {
    install(Vue, options) {
        Vue.prototype.$chatWithUser = (user) => {
            Vue.prototype.$store.commit('setCurrentChatUser', user)
            router.push('/' + Vue.prototype.$store.state.loginUser.role + '/MessagePage')
        }

        Vue.prototype.$chatWithUserId = (id) => {
            Vue.prototype.$axios({
                url: "/user/selectByPk?id=" + id,
                method: 'get',
            }).then((r) => {
                Vue.prototype.$store.commit('setCurrentChatUser', r.data)
                router.push('/' + Vue.prototype.$store.state.loginUser.role + '/MessagePage')
            })
        }
    }
}